import * as React from 'react';
import Viewport, { Main, Header } from './Viewport';
import Nav, { type NavRouteConfig } from './Nav';
import { Route, Redirect, type ContextRouter } from 'react-router-dom';
import Switch from './Switch';
import startCase from 'lodash/startCase';
import { Breadcrumbs } from 'components';
import UserMenu from 'pages/__components__/UserMenu';
import HelpMenu from 'pages/__components__/HelpMenu';
import ClientSelectMenu from 'containers/client/ClientSelectMenu';
import {
  RequireClientSelection,
  ClientContext,
} from 'containers/client/ClientProvider';
import { EmptyCard } from 'components';

type OwnProps = {|
  label: string,
  routes: Array<NavRouteConfig>,
  landingRoute?: string,
|};

type Props = {| ...UserInfo, ...OwnProps, ...ContextRouter |};

const ApplicationErrorMessage = () => (
  <EmptyCard
    title="Something went wrong!"
    message="Try reloading the page. If this error persists, contact PowerReviews Support."
  />
);

const getBreadcrumbs = (pathname, label, routes) => {
  return pathname.split('/').map((pathname, index, array) => {
    let name = startCase(pathname);
    if (index === 1) {
      name = label;
    } else if (index === 2) {
      const matchingDefinedRoute = routes.filter(
        route => route.path === pathname
      )[0];
      name =
        (matchingDefinedRoute && matchingDefinedRoute.label) ||
        startCase(pathname);
    }
    return {
      name,
      path: array.slice(0, index + 1).join('/'),
    };
  });
};

class LandingPage extends React.Component<Props, { error: ?Error }> {
  static contextType = ClientContext;

  state = {
    error: null,
  };

  componentDidCatch(error: Error) {
    this.setState({
      error,
    });
  }

  render() {
    const { match, label, username } = this.props;
    const { routes, landingRoute } = this.props;
    const clientContext = this.context;
    const showClientMenu = Boolean(this.context);

    if (this.state.error) {
      return <ApplicationErrorMessage />;
    }

    return (
      <Viewport>
        <Route
          render={props => (
            <Nav
              contextLabel={label}
              contextRoutes={routes}
              match={this.props.match}
              {...props}
            />
          )}
        />
        <Main>
          <Header>
            <Route
              render={props => (
                <Breadcrumbs
                  routes={getBreadcrumbs(
                    props.location.pathname,
                    label,
                    routes
                  )}
                />
              )}
            />
            <div className="flex flex-row items-center">
              {showClientMenu && <ClientSelectMenu />}
              <UserMenu username={username} />
              <HelpMenu />
            </div>
          </Header>
          <Switch>
            {landingRoute && (
              <Redirect
                exact
                from={match.url}
                to={`${match.url}/${landingRoute}`}
              />
            )}
            {routes.map((route, index) => {
              const {
                exact = false,
                path,
                label,
                component,
                render,
                clientContextRequired = true,
              } = route;
              const routeRenderProp = (() => {
                if (clientContextRequired && clientContext == null) {
                  return {
                    component: RequireClientSelection,
                  };
                }

                return typeof render === 'function'
                  ? { render }
                  : { component };
              })();

              return (
                <Route
                  key={index}
                  exact={exact}
                  path={`${match.url}/${path}`}
                  label={label}
                  {...routeRenderProp}
                />
              );
            })}
          </Switch>
        </Main>
      </Viewport>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/__components__/LandingPage.js